import IMask from 'imask';

export const allowedOperatorCodes = [
	'050', '066', '095', '099', '039', '067', '068', '075', '077',
	'096', '097', '098', '063', '073', '093', '091', '092', '094'
];

const allowedPrefixes = {
	1: new Set(),
	2: new Set(),
	3: new Set()
};

for (const code of allowedOperatorCodes) {
	allowedPrefixes[1].add(code.slice(0, 1));
	allowedPrefixes[2].add(code.slice(0, 2));
	allowedPrefixes[3].add(code);
}

export const createPhoneMaskOptions = () => ({
	mask: '+{38}(XXX)000-00-00',
	overwrite: false,
	blocks: {
		XXX: {
			mask: '000',
			validate(value) {
				return allowedPrefixes[value.length]?.has(value) ?? true;
			}
		}
	}
});

export const createPhoneMask = (input = null) => {
	return input
		? IMask(input, createPhoneMaskOptions())
		: IMask.createMask(createPhoneMaskOptions());
};

const phoneMask = createPhoneMask();

export const required = {
	validate(value, input, form) {
		if (input.tagName === 'SELECT') {
			return input.querySelector('[selected]');
		}

		return value.length > 0;
	},
	message(value, input, form) {
		return form.dataset?.errorRequired;
	},
};

const namePattern = /^[\p{L}\s'’-]+$/u;

export const name = {
	validate(value, input, form) {
		if (!value) {
			return true;
		}

		const trimmed = value.trim();

		return /\p{L}/u.test(trimmed) && namePattern.test(trimmed);
	},
	message(value, input, form) {
		return form.dataset?.errorInvalidName || form.dataset?.errorName;
	},
};

export const phone = {
	validate(value, input, form) {
		return phoneMask.isComplete;
	},
	message(value, input, form) {
		return form.dataset?.errorPhone;
	},
	mask(value, input, form) {
		phoneMask.resolve(value);
		return phoneMask.value;
	},
};

export const email = {
	validate(value, input, form) {
		return !value || value.match(/(.*)@(.*)\.\w{2,}/);
	},
	message(value, input, form) {
		return form.dataset?.errorEmail;
	},
}
